<template>
  <div>
    <b-modal
      v-model="handleOpen"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Confirmação"
    >
      <div class="d-flex flex-column align-items-center">
        <p class="text-center mb-3">Digite a senha de 6 dígitos</p>

        <b-form-input
          v-model="password"
          type="password"
          maxlength="6"
          placeholder="******"
          class="text-center password-input"
          @input="onlyNumbers"
        />

        <div class="d-flex justify-content-center mt-4 w-100">
          <b-button variant="secondary" class="mr-2" @click="closeModal">
            Fechar
          </b-button>

          <b-button
            variant="primary"
            :disabled="password.length !== 6"
            @click="confirmPassword"
          >
            Confirmar
          </b-button>
        </div>
        <hr />
        <b-alert variant="info" show>
          <p class="p-2 text-center">
            Não lembra a senha? Entre em contato com o administrador da área de
            trabalho.
          </p>
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BAlert, BButton, BFormInput } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BButton,
    BFormInput,
    BAlert,
  },
  name: 'two-step-modal',

  props: {
    passModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      password: '',
      handleOpen: false,
    };
  },
  watch: {
    passModal(val) {
      this.handleOpen = val;
    },
  },
  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
  },

  methods: {
    closeModal() {
      this.password = '';
      this.handleOpen = false;
      this.$emit('confirmPassModal', false);
    },

    onlyNumbers() {
      this.password = this.password.replace(/\D/g, '');
    },

    confirmPassword() {
      console.log('Senha digitada:', this.password);

      const data = {
        password: this.password,
        workspace_id: this.currentWorkspace.id,
      };

      this.$store
        .dispatch('checkTwoStepPassword', data)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Autorizado',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          });
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Não Autorizado',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });

      this.closeModal();
    },
  },
};
</script>

<style scoped>
.password-input {
  max-width: 220px;
  font-size: 24px;
  letter-spacing: 8px;
}
</style>
